import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {InviteStores} from './invite.stores';
import {IAppRootStore} from '../../app.root.store';
import {ScreenLoader} from '../../components/screen-loader/screen-loader';
import AppLayoutComponent from '../../layouts/main-layout/index';
import InviteTopBar from './invite-top-bar';
import InviteMainContent from './main-content';

import '@techsee/techsee-ui-common/lib/_shared/icons.css';

interface InviteDesktopViewProps {
    inviteStore?: InviteStores;
    rootStore?: IAppRootStore;
}

@observer
export class InviteDesktopViewComponent extends TechseeBaseComponent<InviteDesktopViewProps> {
    renderInternal(): JSX.Element {
        const {inviteStore} = this.props;

        if (!inviteStore || !inviteStore.inviteFlowManager) {
            return <ScreenLoader />;
        }

        // Infrastructure already provides inviteStore via withStoresProvider
        // No need for manual Provider wrapping
        return (
            <AppLayoutComponent
                topBarComponent={InviteTopBar}
                mainContentComponent={InviteMainContent}
                mainLayoutController={inviteStore.mainLayoutController}
                inviteFlowManager={inviteStore.inviteFlowManager}
            />
        );
    }
}

export const InviteDesktopView = inject('rootStore', 'inviteStore')(InviteDesktopViewComponent) as IReactComponent;
